import { Getters } from 'vuex-smart-module';
import ReturnZipsState from './state';

export default class ReturnZipsGetters extends Getters<ReturnZipsState> {}
